import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { FiSettings } from "react-icons/fi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";

import { Navbar, Sidebar, ThemeSettings } from "./components";
import {
  Ecommerce,
  Editor,
} from "./pages";
import "./App.css";
import axios from "axios";
import { baseUrl } from "./data/baseURL";

import { useStateContext } from "./contexts/ContextProvider";
import AuthPage from "./pages/loginPage";
import Comments from "./pages/Comments";
import Post from "./pages/Posts";
import UserManagement from "./pages/UserManagement/UserManagement";

const App = () => {
  const {
    setCurrentColor,
    setCurrentMode,
    currentMode,
    activeMenu,
    currentColor,
    themeSettings,
    setThemeSettings,
  } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, []);
  
  const [profile, setProfile] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (token) {
        try {
          const response = await axios.get(`${baseUrl}/Auth`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          setProfile(response.data.data);
        } catch (error) {
          localStorage.removeItem("token");
          setToken(null); // Clear token if there is an error
        }
      }
    };

    fetchData();
  }, [token]);

  return (
    <div className={currentMode === "Dark" ? "dark" : ""} dir="rtl">
      <BrowserRouter>
        <div className="flex relative dark:bg-main-dark-bg">
          {token && (
            <div className="fixed end-4 bottom-4" style={{ zIndex: "1000" }}>
              <TooltipComponent content="Settings" position="Top">
                <button
                  type="button"
                  onClick={() => setThemeSettings(true)}
                  style={{ background: currentColor, borderRadius: "50%" }}
                  className="text-3xl text-white p-3 hover:drop-shadow-xl hover:bg-light-gray"
                >
                  <FiSettings />
                </button>
              </TooltipComponent>
            </div>
          )}
          {token && (
            <div className={`w-72 fixed sidebar ${activeMenu ? "dark:bg-secondary-dark-bg bg-white" : "w-0 dark:bg-secondary-dark-bg"}`}>
              <Sidebar profile={profile} />
            </div>
          )}
          <div
            className={
              activeMenu && token
                ? "dark:bg-main-dark-bg bg-main-bg min-h-screen md:ms-72 w-full"
                : "bg-main-bg dark:bg-main-dark-bg w-full min-h-screen flex-2"
            }
          >
            {token && (
              <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
                <Navbar profile={profile} />
              </div>
            )}
            <div>
              {themeSettings && token && <ThemeSettings />}

              <Routes>
                <Route
                  path="/login"
                  element={token ? <Navigate to="/ecommerce" /> : <AuthPage />}
                />
                <Route
                  path="/"
                  element={token ? <Ecommerce /> : <Navigate to="/login" />}
                />
                <Route
                  path="/dashboard"
                  element={token ? <Ecommerce /> : <Navigate to="/login" />}
                />
                <Route
                  path="/ecommerce"
                  element={token ? <Ecommerce /> : <Navigate to="/login" />}
                />
                <Route
                  path="/pics"
                  element={token ? <Post /> : <Navigate to="/login" />}
                />
                <Route
                  path="/admins"
                  element={token ? <UserManagement /> : <Navigate to="/login" />}
                />
                <Route
                  path="/new-pic"
                  element={token ? <Editor /> : <Navigate to="/login" />}
                />
                <Route
                  path="/editor"
                  element={token ? <Editor /> : <Navigate to="/login" />}
                />
                <Route
                  path="/comments"
                  element={token ? <Comments /> : <Navigate to="/login" />}
                />
              </Routes>
            </div>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
};

export default App;
